

import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { createLeanComponentSDK } from '@wix/lean-components-infra/runtime/sdk';
import type { ISelectableContainerInputProps } from '../../../components/SelectableContainerInput/SelectableContainerInput.props';

const sdkSchema = {
  "inputContent": {
    "type": "string",
    "persistence": "cssVar"
  },
  "buttonPosition": {
    "type": "string",
    "persistence": "cssVar"
  },
  "contentGap": {
    "type": "number",
    "persistence": "cssVar"
  },
  "contentAlignment": {
    "type": "string",
    "persistence": "cssVar"
  }
};

const validationSchema: ValidationSchema = {
  "type": [
    "object"
  ],
  "properties": {
    "inputContent": {
      "type": [
        "string"
      ],
      "enum": [
        "Text and Button",
        "Text",
        "Button"
      ]
    },
    "buttonPosition": {
      "type": [
        "string"
      ],
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "contentGap": {
      "minimum": 0,
      "maximum": 100,
      "type": [
        "number"
      ]
    },
    "contentAlignment": {
      "type": [
        "string"
      ],
      "enum": [
        "left",
        "center",
        "right"
      ]
    }
  }
};

const mixins = null;

export const sdk = createLeanComponentSDK<ISelectableContainerInputProps>({
  sdkSchema,
  validationSchema,
  mixins
});

export default createComponentSDKModel(sdk);

